import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { ConditionListItem } from '@/models/dictionary/condition-list.model';

export default class GetConditionListRequest extends ApiResourceMethod<ConditionListItem[]> {
  public perform(whitelabelSlug: string): Promise<ConditionListItem[]> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/dictionary/conditionList`,
      },
      ({ data }: BaseResponse<ConditionListItem[]>): ConditionListItem[] => data,
    );
  }
}
